export default __webpack_public_path__ + "static/media/learn_illus_scratch.3226e96f.png";